import { decideLocale } from '../Functions/shared-utility';
class TranslationUtility {
  private translations = {
    'en-US': require(`../locales/en-US/translations`).translations['en-US'],
    'en-GB': require(`../locales/en-GB/translations`).translations['en-GB'],
    'da-DK': require(`../locales/da-DK/translations`).translations['da-DK'],
    'fr-FR': require(`../locales/fr-FR/translations`).translations['fr-FR'],
    'it-IT': require(`../locales/it-IT/translations`).translations['it-IT'],
    'es-419': require(`../locales/es-419/translations`).translations['es-419'],
    'de-DE': require(`../locales/de-DE/translations`).translations['de-DE'],
    'es-ES': require(`../locales/es-ES/translations`).translations['es-ES']
  };

  getLocale(languageCode: string) {
    return decideLocale(languageCode);
  }

  getTransations() {
    return this.translations;
  }
}

export default new TranslationUtility();
